@if (tenderDetails()?.beginningText) {
  <app-subsection-title key="provider.tender.guidance.rfq.subject" />
  <div class="card p-4 bg-third-level">
    <div [innerHTML]="tenderDetails()?.beginningText"></div>
  </div>
}

<app-trusted-text-preview
  textKey="step_rfq_guidance_proposal_preview_part_1"
></app-trusted-text-preview>
<br />

<app-trusted-text-preview
  textKey="step_rfq_guidance_proposal_preview_part_2"
></app-trusted-text-preview>
<br />

<app-trusted-text-preview
  textKey="step_rfq_guidance_proposal_preview_part_3"
></app-trusted-text-preview>
<br />

<app-trusted-text-preview
  textKey="step_rfq_guidance_proposal_preview_part_4"
></app-trusted-text-preview>
<br />

<app-trusted-text-preview
  textKey="step_rfq_guidance_proposal_preview_part_5"
></app-trusted-text-preview>
